export default __webpack_public_path__ + "static/media/kone-elevator-planner.1cfb0b62.png";